// extracted by mini-css-extract-plugin
module.exports = {"bg":"Header_bg__3R8id","wrap":"Header_wrap__3jxdK","link":"Header_link__3E6jH","lang":"Header_lang__3343K"};